import axios from 'axios';
import {LOGIN_ENDPOINT as LOGIN_URL, API_URL, RESET_PASSWORD} from '@dynameat/constants';

export default {
  login(payload) {
    return axios({ url: LOGIN_URL(payload.subdomain), data: payload, method: 'POST' })
      .then((resp) => resp)
      .catch((err) => {
        throw err;
      });
  },

  get(apiPath, params) {
    return axios
      .get(API_URL + apiPath, {
        params
      });
  },

  post(apiPath, data) {
    return axios.post(API_URL + apiPath, data);
  },

  delete(apiPath, data) {
    return axios.delete(API_URL + apiPath, { data });
  },

  reset_password(payload) {
    return axios.post(RESET_PASSWORD(payload.subdomain), payload)
      .then((resp) => resp)
      .catch((err) => {
        throw err;
      });
  }
};
